import React from 'react';
import { sortBy } from 'lodash';

export function optionsForEnum(enums, placeholder = "") {
  return !!enums ? [<option value='' key='' disabled>{placeholder}</option>].concat(enums.map(e => <option value={e.id} key={e.name}>{e.name}</option>)) : [<option value='' key=''>{placeholder}</option>];
}

export function multiSelectOptionsForEnum(enums) {
  return !!enums ? enums.map(e => {
    return { value: e.id, label: e.name }
  }) : {};
}

export function otherLast(enums) {
  return sortBy(enums, e => (e.name === 'Other' || e.name === 'Other Type') ? 1 : 0);
}

export const getEnumName = (enums, enumId) => {
  return enums?.find(({ id }) => id == enumId)?.name;
}

export const isOtherPresent = (enums, enumId) => {
  if (!enums && !enumId) return false;
  let otherId = enums.find(it => it.name === "Other")?.id || "";
  return Array.isArray(enumId) ? (enumId.includes(otherId) || enumId.includes(otherId.toString())) : enumId == otherId;
}

export const getJobDescriptionNames = (jobs, ids) => {
  return (!!jobs && !!ids) ? `${ids.map(jobId => { return jobs.find(({ id }) => id == jobId)?.name; }).join(", ")}` : '';
}

const AT = 0, RN = 1;
const getSetting = (eventProfessionId) => {
  if (eventProfessionId == AT) return [
    { id: 0, name: 'Industrial' },
    { id: 1, name: 'Medical' },
    { id: 2, name: 'Performing Arts' },
    { id: 3, name: 'School' },
    { id: 4, name: 'Sports' },
  ]
  if (eventProfessionId == RN) return [
    { id: 0, name: 'Industrial' },
    { id: 1, name: 'Medical' },
    { id: 2, name: 'Performing Arts' },
    { id: 3, name: 'School' },
    { id: 4, name: 'Sports' },
  ]
  return [{ id: '', name: '' }];
};

export const getSettingName = (eventProfessionId, settingId) => {
  return getSetting(eventProfessionId)?.find(({ id }) => id === parseInt(settingId))?.name;
}

export const getSettingDetail = (eventProfessionId, settingId) => {
  const settingName = getSettingName(eventProfessionId, settingId);
  if (eventProfessionId == AT) {
    switch (settingName) {
      case 'School':
        return [
          { id: 32, name: 'Athletic Training Room Coverage' },
          { id: 0, name: 'Camp Day' },
          { id: 1, name: 'Camp Overnight' },
          { id: 2, name: 'Clinic' },
          { id: 3, name: 'Game' },
          { id: 4, name: 'League' },
          { id: 5, name: 'Match' },
          { id: 6, name: 'Meet' },
          { id: 7, name: 'Practice' },
          { id: 8, name: 'Showcase' },
          { id: 9, name: 'Tournament' },
          { id: 58, name: 'Other' },
        ]
      case 'Industrial':
        return [
          { id: 10, name: 'Bank' },
          { id: 12, name: 'Construction Site' },
          { id: 13, name: 'Corporate Building' },
          { id: 14, name: 'Distribution Center' },
          { id: 15, name: 'Food Production Facility' },
          { id: 16, name: 'Hospitality Facility' },
          { id: 17, name: 'Manufacturing Facility' },
          { id: 18, name: 'Military Facility' },
          { id: 19, name: 'Public Safety Facility' },
          { id: 58, name: 'Other' },
        ];
      case 'Medical':
        return [
          { id: 20, name: 'Chiropractic Clinic' },
          { id: 21, name: 'Hospital' },
          { id: 22, name: 'Orthopedic Clinic' },
          { id: 23, name: 'Physical Therapy Clinic' },
          { id: 24, name: 'Physician Practice' },
          { id: 25, name: 'Urgent Care' },
          { id: 58, name: 'Other' },
        ];
      case 'Performing Arts':
        return [
          { id: 26, name: 'Circus' },
          { id: 27, name: 'Concert Hall' },
          { id: 28, name: 'Festival' },
          { id: 29, name: 'Production Set' },
          { id: 30, name: 'Theatre' },
          { id: 31, name: 'Training Center' },
          { id: 58, name: 'Other' },
        ];
      case 'Sports':
        return [
          { id: 32, name: 'Athletic Training Room Coverage' },
          { id: 0, name: 'Camp Day' },
          { id: 1, name: 'Camp Overnight' },
          { id: 2, name: 'Clinic' },
          { id: 3, name: 'Game' },
          { id: 4, name: 'League' },
          { id: 5, name: 'Match' },
          { id: 6, name: 'Meet' },
          { id: 7, name: 'Practice' },
          { id: 62, name: 'Race' },
          { id: 8, name: 'Showcase' },
          { id: 9, name: 'Tournament' },
          { id: 58, name: 'Other' },
        ];
      default: return [];
    };
  } else if (eventProfessionId == RN) {
    switch (settingName) {
      case 'School':
        return [
          { id: 55, name: 'Primary School' },
          { id: 56, name: 'Secondary School' },
          { id: 57, name: 'University/College' },
        ]
      case 'Industrial':
        return [
          { id: 34, name: 'Airport' },
          { id: 10, name: 'Bank' },
          { id: 12, name: 'Construction Site' },
          { id: 13, name: 'Corporate Building' },
          { id: 14, name: 'Distribution Center' },
          { id: 15, name: 'Food Production Facility' },
          { id: 16, name: 'Hospitality Facility' },
          { id: 17, name: 'Manufacturing Facility' },
          { id: 18, name: 'Military Facility' },
          { id: 35, name: 'Park' },
          { id: 19, name: 'Public Safety Facility' },
          { id: 58, name: 'Other' },
        ];
      case 'Medical':
        return [
          { id: 36, name: 'Behavioral Health Institution' },
          { id: 11, name: 'Camp' },
          { id: 61, name: 'Clinical Trials' },
          { id: 37, name: 'Concierge Health Care' },
          { id: 38, name: 'Detention Center/Prison' },
          { id: 39, name: 'Home Health Care' },
          { id: 21, name: 'Hospital' },
          { id: 40, name: 'Infusion Center (IV Infusion Center)' },
          { id: 41, name: 'Injection Clinic' },
          { id: 42, name: 'Insurance Company' },
          { id: 43, name: 'Imaging Center' },
          { id: 44, name: 'Long Term Care Facility' },
          { id: 45, name: 'Non Profit Facility' },
          { id: 46, name: 'Pharmacy' },
          { id: 47, name: 'Phone Screening' },
          { id: 59, name: 'Primary Care Facility' },
          { id: 48, name: 'Rehabilitation Facility' },
          { id: 49, name: 'Religious Institution' },
          { id: 60, name: 'Research' },
          { id: 50, name: 'Retreats' },
          { id: 51, name: 'Surgi Center' },
          { id: 52, name: 'Telehealth' },
          { id: 25, name: 'Urgent Care' },
          { id: 53, name: 'Vaccination Clinic' },
          { id: 58, name: 'Other' },
        ];
      case 'Performing Arts':
        return [
          { id: 26, name: 'Circus' },
          { id: 27, name: 'Concert Hall' },
          { id: 28, name: 'Festival' },
          { id: 54, name: 'Outdoor Performance' },
          { id: 29, name: 'Production Set' },
          { id: 30, name: 'Theatre' },
          { id: 31, name: 'Training Center' },
          { id: 58, name: 'Other' },
        ];
      case 'Sports':
        return [
          { id: 0, name: 'Camp Day' },
          { id: 1, name: 'Camp Overnight' },
          { id: 33, name: 'Sporting Event' },
          { id: 58, name: 'Other' },
        ];
      default: return [];
    };
  }
}

export const getJobDescription = (eventProfessionId, settingId = "", settingDetailId = "") => {
  const settingName = getSettingName(eventProfessionId, settingId);
  if (eventProfessionId == AT) {
    switch (settingName) {
      case 'Medical':
      case 'Sports':
      case 'Performing Arts':
      case 'School':
        return [
          { id: 0, name: 'Athletic Training Services' },
          { id: 1, name: 'COVID Screening' },
          { id: 2, name: 'COVID Testing' },
          { id: 18, name: 'Other' },
        ];
      case 'Industrial':
        return [
          { id: 0, name: 'Athletic Training Services' },
          { id: 1, name: 'COVID Screening' },
          { id: 2, name: 'COVID Testing' },
          { id: 3, name: 'Ergonomics' },
          { id: 18, name: 'Other' },
        ];
      default: return [];
    };
  } else if (eventProfessionId == RN) {
    switch (settingName) {
      case 'Industrial':
      case 'Sports':
      case 'Performing Arts':
      case 'School':
        return [
          { id: 1, name: 'COVID Screening' },
          { id: 2, name: 'COVID Testing' },
          { id: 4, name: 'General Patient Care' },
          { id: 18, name: 'Other' },
        ];
      case 'Medical':
        return [
          { id: 5, name: 'Blood Draw' },
          { id: 6, name: 'Central Line Care' },
          { id: 7, name: 'Chest Tube Care' },
          { id: 1, name: 'COVID Screening' },
          { id: 2, name: 'COVID Testing' },
          { id: 8, name: 'Drain Management' },
          { id: 4, name: 'General Patient Care' },
          { id: 9, name: 'IV Infusion' },
          { id: 10, name: 'IV Placement' },
          { id: 11, name: 'Medication Administration' },
          { id: 12, name: 'Neurological Assessment' },
          { id: 13, name: 'Orthopedic Assessment' },
          { id: 14, name: 'PEG/Nasogastric Tube Management' },
          { id: 15, name: 'Trach Care' },
          { id: 16, name: 'Wound Care' },
          { id: 17, name: 'Vaccinations' },
          { id: 18, name: 'Other' },
        ];
      default: return [];
    };
  }
};

export const sportsFilter = (sports) => {
  return sports.filter(item => {
    return item.name !== "Industrial"
  })
}

export const SHIFT_CANCELLATION_REASONS = [
  { id: 'Shift Canceled', name: 'Shift Canceled' },
  { id: 'Position Filled', name: 'Position Filled' },
  { id: 'Incorrectly Posted', name: 'Incorrectly Posted' },
  { id: 'No Applicants', name: 'No Applicants' },
]

export const SECONDARY_REASONS = {
  'Shift Canceled': [
    { id: 'Weather', name: 'Weather' },
    { id: 'Staff no longer needed', name: 'Staff no longer needed' },
    { id: 'Other', name: 'Other' },
  ],
  'Position Filled': [
    { id: 'Staffed through Facility/Venue', name: 'Staffed through Facility/Venue' },
    { id: 'Staffed using another resource', name: 'Staffed using another resource' },
    { id: 'Other', name: 'Other' },
  ],
};